import React from 'react';
import styles from '../styles';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';

const Problem = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();
    const problemStyles = {
        container: {
            ...styles.section,
            backgroundColor: '#f8f9fa',
            padding: isMobile ? '2rem 1rem' : '4rem 2rem',
        },
        headline: {
            ...styles.h2,
            marginBottom: '1rem',
        },
        body: {
            ...styles.bodyText,
            maxWidth: '700px',
            textAlign: 'center',
        }
    };

    return (
        <section style={problemStyles.container}>
            <h2 style={problemStyles.headline}>{t('problem.headline')}</h2>
            <p style={problemStyles.body}>
                {t('problem.body')}
            </p>
        </section>
    );
};

export default Problem;
